/* The playbooks on the shelf at /playbooks/ and under "Playbooks" in the
 * navbar, in shelf order. They are written in markdown in content/playbooks/
 * and edited in /admin; scripts/build-playbooks.js turns each playbook's
 * index.md into src/data/playbooks/catalog.json before every build, so
 * nothing about a playbook is set here.
 *
 * `listed: false` keeps a playbook off the shelf and out of the navbar while
 * its page stays live at its path, for sharing by link. With none listed, the
 * navbar drops the "Playbooks" item altogether.
 *
 * `summary` is the preview the shelf opens onto, and the description search
 * engines and the page's structured data are given. It is held to
 * PREVIEW_MAX characters, the length a search snippet or a social card shows
 * whole; /admin won't save a longer one, and anything longer that arrives
 * another way is cut at a word here.
 *
 * `cover` is a path under static/ (/images/playbooks/<file>), portrait, about
 * 3:4; it shows at its own proportions. Until a playbook has one, the shelf
 * draws a typeset jacket in its place. */

import catalog from "../../data/playbooks/catalog.json";

export const PREVIEW_MAX = 280;

export const clip = (text, max = PREVIEW_MAX) => {
  const flat = String(text || "").replace(/\s+/g, " ").trim();
  if (flat.length <= max) return flat;
  const cut = flat.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(" ")).replace(/[\s,;:.—–-]+$/, "")}…`;
};

const playbooks = catalog.map(p => ({ ...p, summary: clip(p.summary) }));

export const listedPlaybooks = playbooks.filter(p => p.listed);

export default playbooks;
